<template>
  <input
    :id="name"
    :class="{ 'is-invalid': errors }"
    :name="name"
    :max="max"
    :min="min"
    :placeholder="label"
    :readonly="readonly"
    :required="required"
    :step="step"
    type="number"
    :value="value"
    class="form-control"
    @change="$emit('update:data', $event.target.value)"
  />
</template>

<script>
export default {
  props: {
    attribute: { type: String, default: null },
    errors: { type: Array, default: null },
    name: { type: String, default: '' },
    max: { type: Number, default: null },
    min: { type: Number, default: null },
    readonly: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    label: { type: String, default: '' },
    type: { type: String, default: 'text' },
    value: { type: Number, default: 1 },
    step: { type: Number, default: null },
  },
  emits: ['update:data'],
  setup() {},
};
</script>
